export default __webpack_public_path__ + "static/media/add_24px.f063876a.svg";